import React from 'react';
import LensIcon from '@material-ui/icons/Lens';
import RoomServiceIcon from '@material-ui/icons/RoomService';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ListIcon from '@material-ui/icons/List';
import BusinessIcon from '@material-ui/icons/Business';
import DescriptionIcon from '@material-ui/icons/Description';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import PeopleIcon from '@material-ui/icons/People';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ReceiptIcon from '@material-ui/icons/Receipt';
import EmailIcon from '@material-ui/icons/Email';
import WorkIcon from '@material-ui/icons/Work';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PersonIcon from '@material-ui/icons/Person';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import LaunchIcon from '@material-ui/icons/Launch';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import PublishIcon from '@material-ui/icons/Publish';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import GridOnIcon from '@material-ui/icons/GridOn';
import RoomServiceOutlinedIcon from '@material-ui/icons/RoomServiceOutlined';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import PaymentIcon from '@material-ui/icons/Payment';

/*
1	Assinaturas
2	Serviços Contratados
3	Cobranças
4	Empresas
5	Das
6	Cnd
7	Clientes
8	Plano de Assinatura
9	Forma de Pagamento
10	Serviços
11	Enviar Email
12	Documentos Usuario
13	Atividades
14	Notificar Usuário
15	Municípios HM
16	Perfis
17	Acessos
18	Usuarios
19	Lançamento
20	Listar Receitas
21	Importar
*/

function IconMenu(menu) {
  if (menu.id === 1) {
    return <ListIcon />;
  }
  if (menu.id === 2) {
    return <RoomServiceIcon />;
  }
  if (menu.id === 3) {
    return <ReceiptIcon />;
  }
  if (menu.id === 4) {
    return <BusinessIcon />;
  }
  if (menu.id === 5 || menu.id === 26 || menu.id === 41) {
    return <DescriptionIcon />;
  }
  if (menu.id === 6) {
    return <DescriptionIcon />;
  }
  if (menu.id === 7 || menu.id === 36 || menu.rota === '/PagamentoComCartao') {
    return <PeopleOutlineIcon />;
  }
  if (menu.id === 8) {
    return <ListAltIcon />;
  }
  if (menu.id === 9) {
    return <CreditCardIcon />;
  }
  if (menu.id === 10 || menu.id === 24) {
    return <RoomServiceIcon />;
  }
  if (menu.id === 11 || menu.id === 23 || menu.id === 42) {
    return <EmailIcon />;
  }
  if (menu.id === 12) {
    return <DescriptionIcon />;
  }
  if (menu.id === 13) {
    return <WorkIcon />;
  }
  if (menu.id === 14) {
    return <AddAlertIcon />;
  }
  if (menu.id === 15) {
    return <LocationCityIcon />;
  }
  if (menu.id === 16) {
    return <PeopleAltIcon />;
  }
  if (menu.id === 17) {
    return <PermIdentityIcon />;
  }
  if (menu.id === 18) {
    return <PeopleIcon />;
  }
  if (menu.id === 19) {
    return <LaunchIcon />;
  }
  if (menu.id === 20) {
    return <PlaylistAddIcon />;
  }
  if (menu.id === 21) {
    return <PublishIcon />;
  }
  if (menu.id === 25 || menu.id === 33) {
    return <MonetizationOnIcon />;
  }
  if (menu.id === 30) {
    return <ListIcon />;
  }
  if (menu.id === 35 || menu.id === 37) {
    return <AccountBalanceIcon />;
  }
  if (menu.id === 39 || menu.rota === '/usuarioAssinatura') {
    return <GridOnIcon />;
  }

  if (menu.rota === '/usuarioDados') {
    return <PersonIcon />;
  }
  if (menu.rota === '/usuarioEndereco') {
    return <ContactMailIcon />;
  }
  if (menu.rota === '/usuarioEmpresa') {
    return <BusinessIcon />;
  }

  if (menu.rota === '/meiosPagamento') {
    return <PaymentIcon />;
  }

  if (menu.id === 3) {
    return <RoomServiceOutlinedIcon />;
  }
  return <LensIcon />;
}

export default IconMenu;
